import { useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import Modal from '../../../components/ui/Modal';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import { getErrorMessage } from '../../../lib/apiClient';
import { createFolder } from '../filesApi';

export default function NewFolderModal({ open, onClose, parentId }) {
  const [name, setName] = useState('');
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: () => createFolder({ name: name.trim(), parentId }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['folder-contents'] });
      queryClient.invalidateQueries({ queryKey: ['move-picker'] });
      toast.success('Folder created');
      handleClose();
    },
    onError: (error) => toast.error(getErrorMessage(error, 'Could not create folder')),
  });

  const handleClose = () => {
    setName('');
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      title="New folder"
      footer={
        <>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button onClick={() => mutation.mutate()} loading={mutation.isPending} disabled={!name.trim()}>
            Create
          </Button>
        </>
      }
    >
      <Input
        label="Folder name"
        value={name}
        autoFocus
        onChange={(e) => setName(e.target.value)}
        onKeyDown={(e) => e.key === 'Enter' && name.trim() && mutation.mutate()}
        placeholder="e.g. Invoices"
      />
    </Modal>
  );
}
